var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/32px/telegram") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/32px/telegram",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "telegram-brands",
    transform: "translate(4.000000, 4.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C5.37256452,0 0,5.37256452 0,12 C0,18.6274355 5.37256452,24 12,24 C18.6274355,24 24,18.6274355 24,12 C24,5.37256452 18.6274355,0 12,0 Z M17.5621935,8.16096774 C17.3816129,10.0584677 16.6002097,14.663129 16.2025161,16.7883871 C16.0343226,17.6876129 15.7030645,17.9891613 15.3824516,18.018629 C14.6856774,18.0827903 14.1564194,17.558129 13.4814677,17.1156774 C12.4253226,16.4233548 11.8286613,15.992371 10.8034355,15.3167903 C9.61867742,14.5360645 10.3867258,14.1071129 11.0619194,13.4055 C11.238629,13.2219677 14.3090323,10.4292097 14.3684516,10.1758548 C14.3758548,10.1441613 14.3829677,10.0258548 14.3126129,9.96372581 C14.2422581,9.90159677 14.1389032,9.92264516 14.0641452,9.93953226 C13.9582419,9.96359677 12.2710161,11.0787903 9.00246774,13.2851129 C8.52359677,13.6139516 8.08982258,13.7741774 7.70114516,13.7657903 C7.27267742,13.7565484 6.4485,13.5235645 5.83577419,13.3243548 C5.08427419,13.0800968 4.48698387,12.9509516 4.539,12.5360806 C4.56609677,12.3199516 4.86367742,12.0989839 5.43174194,11.8731774 C8.93,10.3490484 11.2627097,9.34420968 12.429871,8.85866129 C15.7623871,7.47251613 16.4548548,7.23174194 16.9062097,7.2236342 C17.0055,7.22206452 17.2274516,7.24664516 17.3712097,7.36330645 C17.4668393,7.44641077 17.5277945,7.56238096 17.5420161,7.68827419 C17.5663775,7.84459037 17.5731455,8.00314418 17.5621935,8.16096774 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.530d8bc2022bcd046baac1bccfecfce9.svg";
export { ForwardRef as ReactComponent };